import { render, staticRenderFns } from "./AddNewSkill.vue?vue&type=template&id=7067e8ff&scoped=true"
import script from "./AddNewSkill.vue?vue&type=script&lang=ts"
export * from "./AddNewSkill.vue?vue&type=script&lang=ts"
import style0 from "./AddNewSkill.vue?vue&type=style&index=0&id=7067e8ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7067e8ff",
  null
  
)

export default component.exports